import React, { useEffect, useState } from "react";
import { Card, Button, Spinner, Alert, Container } from "react-bootstrap";
import axios from "axios";
import KpiService from "../../Services/KpiService";
import { backgroundColor, textAlign } from "@mui/system";
import {
  FaDownload,
  FaFilePdf,
  FaFileExcel,
  FaLeaf,
  FaUtensils,
  FaMicrochip,
  FaCity,
    FaBullseye,
  FaCoins,
  FaLaptopCode,
  FaRoad,
  FaCrosshairs,
  FaTasks,
  FaBuilding
} from "react-icons/fa";
import { store } from "../../App";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Menubar from "../Menubar";
import * as XLSX from "xlsx-js-style";
import { FaRoadBridge } from "react-icons/fa6";
import { downloadpdf } from "../utils/commonFunctions";
import { AiOutlineSearch } from "react-icons/ai";

const FeedbackReportt = () => {
  const [themes, setThemes] = useState([]);
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [tableSearch, setTableSearch] = useState("");
  

   const userid = localStorage.getItem("username");
  const deptid = localStorage.getItem("deptid");
  const roleid = localStorage.getItem("role");

  useEffect(() => {
    getThemes();
  }, []);

  const getThemes = async () => {
  setLoading(true);
  setError("");

  try {
    const params = {
      mode: "dashboarddata",
      userId: userid,
      districtId: "0",
      deptId: roleid === "8" ? "0" : deptid,
    };

    console.log("Dashboard API params:", params);

    const response =
      await KpiService.snccsFeedbackFormDashboard(params);

    console.log("Dashboard API response:", response);

    if (
      response &&
      response.data &&
      response.data.SCODE === "01" &&
      Array.isArray(response.data.SDESC)
    ) {
      // const records = response.data.SDESC;
      const records = response.data.SDESC.filter( (item) => item.is_finalsubmit === true );

      const uniqueThemes = [];

      records.forEach((item) => {
        const topicId = item.name_of_topic;

        const existingTheme = uniqueThemes.find(
          (theme) => theme.name_of_topic === topicId
        );

        if (!existingTheme) {
          uniqueThemes.push({
            name_of_topic: topicId,
            topic_des: item.topic_des,
            records: [item],
          });
        } else {
          existingTheme.records.push(item);
        }
      });

      console.log("Unique Themes:", uniqueThemes);

      uniqueThemes.sort((a, b) => {
            return Number(a.name_of_topic) - Number(b.name_of_topic);
            });

            setThemes(uniqueThemes);
            setSelectedTheme(uniqueThemes.length > 0 ? uniqueThemes[0] : null);
            // setSelectedTheme(null);
    } else {
      setThemes([]);
      console.log("No theme data found");
    }
  } catch (err) {
    console.error("Error fetching themes:", err);
    setError("Unable to load themes. Please try again.");
  } finally {
    setLoading(false);
  }
};

  /*
   * Theme click
   */
  const handleThemeSelect = (theme) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    setSelectedTheme(theme);
    store.dispatch({ type: "HIDE_SPINNER" });
  };

  /*
   * Back to all themes
   */
  const handleBack = () => {
    setSelectedTheme(null);
  };

const downloadTablePDF = () => {
  if (!selectedTheme || !selectedTheme.records?.length) {
    return;
  }

  store.dispatch({ type: "SHOW_SPINNER" });

  try {
    // A4 Portrait
    const doc = new jsPDF("portrait", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth(); // 210 mm
    const topic = selectedTheme.topic_des || "Theme";

    // =========================
    // TITLE
    // =========================
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");

    doc.text(
      "Sixth National Conference of Chief Secretaries Feedback Note Compiled Summary",
      pageWidth / 2,
      15,
      {
        align: "center",
      }
    );

    // =========================
// STATE
// =========================
doc.setFontSize(11);
doc.setFont("helvetica", "bold");

doc.text( "Name of the State: Andhra Pradesh", 10, 23 );

// =========================
// THEME
// =========================
// doc.setFontSize(11);
// doc.setFont("helvetica", "bold");
// doc.text( `Theme: ${topic}`, 10, 30 );

doc.setFontSize(11);
doc.setFont("helvetica", "bold");

doc.text( `Topic: ${topic}`, 10, 30 );

// =========================
// OFFICER COUNT
// =========================
doc.setFontSize(10);
doc.setFont("helvetica", "bold");

doc.text(
  `No. of officers who have written feedback note on this topic: ${selectedTheme.records.length}`,
  10,
  37
);

    // =========================
    // TABLE DATA
    // =========================
    
const tableData = selectedTheme.records
  .slice()
  .sort((a, b) =>
    `${a.f_name || ""} ${a.l_name || ""}`.trim().localeCompare(
      `${b.f_name || ""} ${b.l_name || ""}`.trim(),
      undefined,
      { sensitivity: "base" }
    )
  )
  .map((record, index) => [
    index + 1,
    getOfficerName(record),
    getCurrentPosting(record),
  ]);


    // =========================
    // TABLE
    // =========================
    autoTable(doc, {
      startY: 45,

      head: [
        ["S.No", "Name", "Current Posting"]
      ],

      body: tableData,

      theme: "grid",

      styles: {
        fontSize: 9,
        cellPadding: 3,
        valign: "middle",
        lineColor: [148, 163, 184],
        lineWidth: 0.2,
      },

      headStyles: {
        fillColor: false,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
      },

      columnStyles: {
        // S.No
        0: {
          cellWidth: 18,
          halign: "center",
        },

        // Name
        1: {
          cellWidth: 55,
          halign: "left",
        },

        // Current Posting
        2: {
          cellWidth: 117,
          halign: "left",
        },
      },

      margin: {
        left: 10,
        right: 10,
      },

      tableWidth: "auto",
    });

    // =========================
    // FILE NAME
    // =========================
    const safeFileName = topic
      .replace(/[^a-zA-Z0-9]/g, "_")
      .substring(0, 50);

    doc.save(
      `SNCCS_Feedback_${safeFileName}.pdf`
    );

  } catch (error) {
    console.error(
      "Error downloading table PDF:",
      error
    );

    alert("Unable to download PDF.");

  } finally {
    store.dispatch({
      type: "HIDE_SPINNER",
    });
  }
};

const downloadTableExcel = () => {
  if (!selectedTheme || !selectedTheme.records?.length) {
    return;
  }

  store.dispatch({ type: "SHOW_SPINNER" });

  try {
    const topic = selectedTheme.topic_des || "Theme";

    // =========================
    // EXCEL DATA
    // =========================

    const excelData = [
      // Heading in ONE CELL
      [`Name of the State: Andhra Pradesh`],

      // Heading in ONE CELL
    //   [`Theme: ${topic}`],
      [`Topic: ${topic}`],

      // Heading in ONE CELL
      [
        `No. of officers who have written feedback note on this topic: ${selectedTheme.records.length}`
      ],

      // Empty row
      [],

      // Table headings
      [
        "S.No",
        "Name",
        "Current Posting"
      ],

      // Table data
      
...selectedTheme.records
  .slice()
  .sort((a, b) =>
    `${a.f_name || ""} ${a.l_name || ""}`.trim().localeCompare(
      `${b.f_name || ""} ${b.l_name || ""}`.trim(),
      undefined,
      { sensitivity: "base" }
    )
  )
  .map((record, index) => [
    index + 1,
    getOfficerName(record),
    getCurrentPosting(record),
  ])

    ];

    // =========================
    // CREATE WORKSHEET
    // =========================

    const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    // =========================
    // MERGE A:C FOR HEADINGS
    // =========================

    worksheet["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: 2 }
      },
      {
        s: { r: 1, c: 0 },
        e: { r: 1, c: 2 }
      },
      {
        s: { r: 2, c: 0 },
        e: { r: 2, c: 2 }
      }
    ];

    // =========================
    // COLUMN WIDTHS
    // =========================

    worksheet["!cols"] = [
      { wch: 12 },
      { wch: 35 },
      { wch: 50 }
    ];

    // =========================
    // HEADING STYLES
    // =========================

    worksheet["A1"].s = {
      font: {
        bold: true
      }
    };

    worksheet["A2"].s = {
      font: {
        bold: true
      }
    };

    worksheet["A3"].s = {
      font: {
        bold: true
      }
    };

    // =========================
    // TABLE HEADER STYLE
    // =========================

    worksheet["A5"].s = {
      font: {
        bold: true
      }
    };

    worksheet["B5"].s = {
      font: {
        bold: true
      }
    };

    worksheet["C5"].s = {
      font: {
        bold: true
      }
    };

    // =========================
    // CREATE WORKBOOK
    // =========================

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Feedback"
    );

    // =========================
    // FILE NAME
    // =========================

    const safeFileName = topic
      .replace(/[^a-zA-Z0-9]/g, "_")
      .substring(0, 50);

    XLSX.writeFile(
      workbook,
      `SNCCS_Feedback_${safeFileName}.xlsx`
    );

  } catch (error) {
    console.error("Error downloading table Excel:", error);
    alert("Unable to download Excel.");
  } finally {
    store.dispatch({ type: "HIDE_SPINNER" });
  }
};

const filteredRecords = (selectedTheme?.records || [])
  .filter((record) => {
    const search = tableSearch.toLowerCase().trim();

    const name = `${record.f_name || ""} ${record.l_name || ""}`.trim();

    const currentPosting = `${record.designation || ""} ${
      record.current_posting || ""
    } ${record.district_name || ""}`;

    return (
      name.toLowerCase().includes(search) ||
      currentPosting.toLowerCase().includes(search)
    );
  })
  .sort((a, b) => {
    const nameA = `${a.f_name || ""} ${a.l_name || ""}`.trim();
    const nameB = `${b.f_name || ""} ${b.l_name || ""}`.trim();

    return nameA.localeCompare(nameB, undefined, {
      sensitivity: "base",
    });
  });

  const toTitleCase = (value) => {
  return (value || "")
    .toLowerCase()
    .replace(/\b[a-z]/g, (char) => char.toUpperCase());
};


const getOfficerName = (record) => {
  return (
    toTitleCase(
      `${record.f_name || ""} ${record.l_name || ""}`.trim()
    ) || "-"
  );
};

const getCurrentPosting = (record) => {
  const designation = record.designation || "";
  const currentPosting = record.current_posting || "";
  const districtName = record.district_name || "";

  const posting = `${designation}${
    designation && currentPosting ? " " : ""
  }${currentPosting}${
    districtName ? ` - ${districtName}` : ""
  }`.trim();

  return posting ? toTitleCase(posting) : "-";
};



  return (
   <>
     
        
    <Menubar />
    <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
            <Container fluid style={{ width: "96%"}}> <div className="sa-title"> <h2>Sixth National Conference of Chief Secretaries  <span> Feedback Report</span>  </h2> </div> </Container>

    
    <div style={styles.pageContainer}>

      {/* PAGE HEADER */}
      {/* <div style={styles.header}>
        <div>
          <h2 style={styles.heading}>
            Sixth National Conference of Chief Secretaries Feedback Note
          </h2>

          <p style={styles.subHeading}>
            Select a theme 
          </p>
        </div>
      </div> */}

      {/* LOADING */}
      {loading && (
        <div style={styles.loadingContainer}>
          <Spinner animation="border" />
          <span style={{ marginLeft: "10px" }}>
            Loading themes...
          </span>
        </div>
      )}

      {/* ERROR */}
      {!loading && error && (
        <Alert variant="danger">
          {error}
        </Alert>
      )}

      {/* =============================== */}
      {/* ALL THEMES */}
      {/* =============================== */}

      {!loading && themes.length > 0 && (
        <>
         

        

{/* <div
  style={{
    ...styles.themeGrid,
    gridTemplateColumns:
      themes.length === 1
        ? "340px"
        : themes.length === 2
        ? "repeat(2, minmax(0, 1fr))"
        : "repeat(4, minmax(0, 1fr))",
    maxWidth:
      themes.length === 1
        ? "100%"
        : themes.length === 2
        ? "700px"
        : "100%",
    justifyContent: themes.length === 1 ? "center" : "stretch",
    margin: themes.length <= 2 ? "0 auto" : "0",
  }}
> */}

  
<div
  style={{
    ...styles.themeGrid,
    gridTemplateColumns:
      themes.length === 1
        ? "340px"
        : themes.length === 2
        ? "repeat(2, minmax(0, 1fr))"
        : themes.length === 3
        ? "repeat(3, minmax(0, 1fr))"
        : "repeat(4, minmax(0, 1fr))",
    maxWidth:
      themes.length === 1
        ? "100%"
        : themes.length === 2
        ? "700px"
        : themes.length === 3
        ? "950px"
        : "100%",
    justifyContent: "center",
    margin: themes.length <= 3 ? "0 auto" : "0",
  }}
>






{themes.map((theme, index) => {

const themeIcons = [
  FaTasks,
  FaCoins,
  FaLaptopCode,
  FaBuilding
];

  const ThemeIcon = themeIcons[index % themeIcons.length];

  return (
    <div
      key={theme.name_of_topic}
      style={styles.themeCardWrapper}
    >
      <Card
  style={{
    ...styles.themeCard,
    ...(selectedTheme?.name_of_topic === theme.name_of_topic
      ? styles.selectedThemeCard
      : {}),
  }}
  onClick={() => handleThemeSelect(theme)}
>
  {/* LEFT ICON */}
  <div
    style={{
      ...styles.themeIconCircle,
      backgroundColor:
        index === 0
          ? "#249b4b"
          : index === 1
          ? "#6fa8e8"
          : index === 2
          ? "#9b7be3"
          : "#f5a365",
    }}
  >
    <ThemeIcon size={25} />
  </div>

  {/* RIGHT CONTENT */}
  <div style={styles.themeCardContent}>

    <div style={styles.themeCardTitle}>
      {theme.topic_des}
    </div>

    <div style={styles.themeResponse}>
      {theme.records.length} Officer
      {theme.records.length !== 1 ? "s" : ""}
    </div>

  </div>

  {/* TOP RIGHT SELECTION */}
  <div
    style={{
      ...styles.themeSelectCircle,
      ...(selectedTheme?.name_of_topic === theme.name_of_topic
        ? styles.themeSelectedCircle
        : {}),
    }}
  >
    {selectedTheme?.name_of_topic === theme.name_of_topic && "✓"}
  </div>
</Card>
    </div>
  );
})}

          </div>
        </>
      )}

      {/* NO DATA */}
      {!loading &&
        !selectedTheme &&
        themes.length === 0 &&
        !error && (
          <div style={styles.noData}>
            No themes available.
          </div>
        )}

      {/* =============================== */}
      {/* SELECTED THEME */}
      {/* =============================== */}

      {!loading && selectedTheme && (
  <div style={styles.selectedContainer}>

    {/* BACK BUTTON */}
    {/* <button
      type="button"
      style={styles.backButton}
      onClick={handleBack}
    >
      ← Back to Themes
    </button> */}

    {/* SELECTED THEME */}
   {/* <div style={styles.selectedThemeHeader}>

  <div style={styles.infoRow}>
    <span style={styles.infoLabel}>Name of the State:</span>
    <span style={styles.infoValue}>Andhra Pradesh</span>
  </div>

  <div style={styles.infoRow}>
    <span style={styles.infoLabel}>Theme:</span>
    <span style={styles.infoValue}>
      {selectedTheme.topic_des}
    </span>
  </div>

  <div style={styles.infoRow}>
    <span style={styles.infoLabel}>
      No. of officers who have written feedback note on this topic:
    </span>
    <span style={styles.infoValue}>
      {selectedTheme.records.length}
    </span>
  </div>

</div> */}

<div style={styles.tableSearchContainer}>
  <AiOutlineSearch
    style={{
      position: "absolute",
      left: "12px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#777",
      fontSize: "18px",
      zIndex: 1,
    }}
  />

  <input
    type="text"
    placeholder="Search..."
    value={tableSearch}
    onChange={(e) => setTableSearch(e.target.value)}
    style={styles.tableSearchInput}
  />

  {tableSearch && (
    <button
      type="button"
      onClick={() => setTableSearch("")}
      style={styles.tableSearchClear}
    >
      ×
    </button>
  )}
</div>

<div style={styles.selectedThemeHeader}>

  {/* LEFT SIDE */}
  <div style={styles.themeInfoSection}>

     <div style={{ ...styles.infoRow, display: "none" }} >
      <span style={styles.infoLabel}>Name of the State:</span>
      <span style={styles.infoValue}>Andhra Pradesh</span>
    </div>


    {/* <div style={styles.infoRow}>
      <span style={styles.infoLabel}>Theme:</span>
      <span style={styles.infoValue}>
        {selectedTheme.topic_des}
      </span>
    </div> */}

    <div style={styles.infoRow}>
      <span style={styles.infoLabel}>Topic:</span>
      <span style={styles.infoValue}>
        {selectedTheme.topic_des}
      </span>
    </div>


    <div style={styles.infoRow}>
      <span style={styles.infoLabel}>
        No. of officers who have written feedback note on this topic:
      </span>
      <span style={styles.infoValue}>
        {selectedTheme.records.length}
      </span>
    </div>
    

  </div>

  {/* RIGHT SIDE */}
  <div style={styles.downloadButtons}>

    <button
      type="button"
      onClick={downloadTablePDF}
      style={styles.pdfIconButton}
      title="Download PDF"
    >
      <FaFilePdf size={20} />
    </button>

    <button
      type="button"
      onClick={downloadTableExcel}
      style={styles.excelIconButton}
      title="Download Excel"
    >
      <FaFileExcel size={20} />
    </button>

  </div>

</div>






    {/* TABLE */}


<div style={styles.tableContainer}>
   

      <table style={styles.feedbackTable}>

        <thead>
          <tr>

            <th style={styles.th}>
              S.No
            </th>

            <th style={styles.th}>
              Name
            </th>

            <th style={styles.th}>
              Current Posting 
            </th>

             <th style={styles.th}>
              Action
            </th>

          </tr>
        </thead>

        <tbody>

         {filteredRecords.length > 0 ? (

            filteredRecords.map((record, index) => (

              <tr
                key={record.sno || index}
                style={styles.tableRow}
              >

                {/* S.NO */}
                <td style={styles.tdCenter}>
                  {index + 1}
                </td>

                {/* NAME */}
                <td style={{ ...styles.td, textAlign: "left" }}>
                   {toTitleCase( `${record.f_name || ""} ${record.l_name || ""}`.trim() ) || "-"}
                  {/* {`${record.f_name || ""} ${ record.l_name || "" }`.trim().toUpperCase()  || "-"} */}
                </td>

                {/* CURRENT POSTING */}
                
             
                {/* <td style={{ ...styles.td, textAlign: "left" }}>
                {record.designation || record.current_posting || record.district_name
                    ? `${record.designation || ""}${
                        record.designation && record.current_posting ? " " : ""
                    }${record.current_posting || ""}${
                        record.district_name ? ` - ${record.district_name}` : ""
                    }`
                    : "-"}
                </td> */}

                <td style={{ ...styles.td, textAlign: "left" }}>
                    {record.designation || record.current_posting || record.district_name
                      ? toTitleCase(
                          `${record.designation || ""}${
                            record.designation && record.current_posting ? " " : ""
                          }${record.current_posting || ""}${
                            record.district_name ? ` - ${record.district_name}` : ""
                          }`
                        )
                      : "-"}
                  </td>


                
               <td>
                <button
              type="button"
              className="topic-action-btn view-btn"
              onClick={() => downloadpdf(record)}
            >
              View<FaDownload className="mb-1 ms-1" />
            </button></td>

              </tr>

            ))

          ) : (

            <tr>

              <td
                colSpan={3}
                style={styles.noRecords}
              >
                {tableSearch ? "No records found for your search." : "No records available for this theme."}
              </td>

            </tr>

          )}

        </tbody>

      </table>

    </div>

  </div>
)}

    </div></Container> </>
  );
};


/* ===================================================== */
/* INLINE CSS */
/* ===================================================== */

const styles = {

  pageContainer: {
    minHeight: "100vh",
    backgroundColor: "#fff",
    padding: "30px 40px",
    fontFamily:
      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },

  header: {
    // background:
    //   "linear-gradient(135deg, #173b68 0%, #245d91 100%)",
    background: "#97a35a",
    borderRadius: "14px",
    padding: "25px 30px",
    marginBottom: "30px",
    color: "#ffffff",
    boxShadow:
      "0 6px 20px rgba(20, 55, 95, 0.15)",
  },

  heading: {
    margin: 0,
    fontSize: "25px",
    fontWeight: 700,
    letterSpacing: "0.2px",
  },

  subHeading: {
    margin: "7px 0 0",
    fontSize: "14px",
    opacity: 0.85,
  },

  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },

  sectionTitle: {
    margin: 0,
    fontSize: "21px",
    fontWeight: 700,
    color: "#1e293b",
  },

  sectionDescription: {
    margin: "5px 0 0",
    color: "#64748b",
    fontSize: "14px",
  },

  themeCount: {
    backgroundColor: "#e8f1fb",
    color: "#1d4f7a",
    padding: "8px 15px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: 600,
  },

themeGrid: {
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: "18px",
  width: "100%",
  justifyContent: "stretch",
  alignItems: "stretch",
},

themeCardWrapper: {
  minWidth: 0,
},

themeCard: {
  position: "relative",

  height: "140px",
  minHeight: "140px",

  width: "100%",

  border: "1px solid #909091",
  borderRadius: "14px",

  overflow: "hidden",
  cursor: "pointer",

  backgroundColor: "#fdfefe",

  /* VERY IMPORTANT */
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",

  padding: "18px 38px 18px 22px",

  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",

  transition: "all 0.2s ease",

  boxSizing: "border-box",
},



themeIconCircle: {
  width: "60px",
  height: "60px",
  minWidth: "60px",

  borderRadius: "50%",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  color: "#ffffff",

  marginRight: "20px",

  flexShrink: 0,

  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.12)",
},
themeCardContent: {
  flex: 1,
  minWidth: 0,

  height: "100%",

  display: "flex",
  flexDirection: "column",

  justifyContent: "center",

  textAlign: "left",

  position: "relative",
},

themeCardTitle: {
  fontSize: "13px",

  lineHeight: "1.4",

  fontWeight: 700,

  color: "#526b87",

  paddingRight: "8px",

  textAlign: "left",

  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",

  overflow: "hidden",
},

tableSearchContainer: {
  position: "relative",
  width: "220px",
  marginBottom: "12px",
  marginLeft: "auto",
},

tableSearchInput: {
  width: "100%",
  height: "40px",
  padding: "8px 35px 8px 40px",
  border: "1px solid #ccc",
  borderRadius: "7px",
  outline: "none",
  fontSize: "14px",
  color: "#334155",
  backgroundColor: "#fff",
  boxSizing: "border-box",
},

tableSearchClear: {
  position: "absolute",
  right: "10px",
  top: "50%",
  transform: "translateY(-50%)",
  border: "none",
  background: "transparent",
  color: "#777",
  fontSize: "20px",
  cursor: "pointer",
  padding: "0",
  lineHeight: "1",
},

themeSelectCircle: {
  position: "absolute",

  top: "10px",
  right: "10px",

  width: "16px",
  height: "16px",

  borderRadius: "50%",

  border: "1px solid #d6e0eb",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  fontSize: "9px",
  fontWeight: 700,

  color: "#ffffff",
  backgroundColor: "#ffffff",
},

themeSelectedCircle: {
  backgroundColor: "#249b4b",
  border: "1px solid #249b4b",
},
themeResponse: {
  position: "absolute",

  right: "0px",
  bottom: "0px",

  fontSize: "11px",
  fontWeight: 700,

  color: "#2563eb",
  backgroundColor: "#eef5ff",

  padding: "5px 10px",

  borderRadius: "12px",

  lineHeight: "1.2",

  whiteSpace: "nowrap",
},

  recordCount: {
    fontSize: "12px",
    color: "#64748b",
    fontWeight: 600,
  },

  selectText: {
    color: "#2563eb",
    fontSize: "13px",
    fontWeight: 700,
  },

  loadingContainer: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#475569",
  },

  noData: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "50px",
    textAlign: "center",
    color: "#64748b",
  },

selectedContainer: {
  maxWidth: "1200px",
  margin: "35px auto 0",
},

  backButton: {
    border: "none",
    backgroundColor: "transparent",
    color: "#2563eb",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    padding: "0",
    marginBottom: "18px",
  },

selectedThemeHeader: {
  background: "linear-gradient(135deg, #eef5fc 0%, #f8fbff 100%)",
  padding: "22px 30px",
  borderRadius: "12px",
  marginBottom: "20px",
  border: "1px solid #cbddec",
  boxShadow: "0 4px 12px rgba(23, 59, 104, 0.08)",

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
},

infoRow: {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  marginBottom: "10px",
  fontSize: "15px",
  textAlign: "left",
  lineHeight: "1.5",
},

infoLabel: {
  fontWeight: "700",
  color: "#173b68",
  marginRight: "8px",
},

infoValue: {
  fontWeight: "600",
  color: "#334155",
},


downloadButtons: {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
  marginLeft: "30px",
},

pdfIconButton: {
  width: "42px",
  height: "42px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #dc2626",
  backgroundColor: "#fff5f5",
  color: "#dc2626",
  borderRadius: "7px",
  cursor: "pointer",
},

excelIconButton: {
  width: "42px",
  height: "42px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #15803d",
  backgroundColor: "#f0fdf4",
  color: "#15803d",
  borderRadius: "7px",
  cursor: "pointer",
},

  
  tableContainer: {
  width: "100%",
  maxHeight: "400px",
  overflowY: "auto",
  overflowX: "auto",
  border: "1px solid #ddd",
  borderRadius: "8px",
},

feedbackTable: {
  width: "100%",
  minWidth: "800px",
  borderCollapse: "separate",
  borderSpacing: 0,
  border: "1px solid #94a3b8",
},

th: {
  padding: "12px 15px",
  borderRight: "1px solid #94a3b8",
  borderBottom: "1px solid #64748b",
  backgroundColor: " #245d91",
  color: "#fff",
  textAlign: "left",
  fontSize: "13px",
  fontWeight: 700,

  position: "sticky",
  top: 0,
  zIndex: 10,
},

  selectedNumber: {
    display: "inline-block",
    backgroundColor: "rgba(255,255,255,0.16)",
    borderRadius: "20px",
    padding: "6px 13px",
    fontSize: "12px",
    fontWeight: 700,
    marginBottom: "13px",
  },

  selectedTitle: {
    margin: 0,
    fontSize: "24px",
    lineHeight: 1.4,
    fontWeight: 700,
  },

  selectedDescription: {
    margin: "10px 0 0",
    fontSize: "13px",
    opacity: 0.85,
  },
  selectedThemeCard: {
  border: "3px solid #2563eb",
  backgroundColor: "#eff6ff",
  boxShadow: "0 8px 24px rgba(37, 99, 235, 0.25)",
  transform: "translateY(-3px)",
  
},

  recordsSection: {
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    padding: "24px",
    border: "1px solid #e2e8f0",
  },

  recordsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },

  recordsTitle: {
    margin: 0,
    fontSize: "19px",
    fontWeight: 700,
    color: "#1e293b",
  },

  recordsBadge: {
    backgroundColor: "#eff6ff",
    color: "#2563eb",
    borderRadius: "20px",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },

  recordsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: "18px",
  },

  recordCard: {
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow:
      "0 2px 8px rgba(15,23,42,0.04)",
  },

  recordHeader: {
    padding: "13px 16px",
    borderBottom: "1px solid #eef2f7",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  recordNumber: {
    color: "#475569",
    fontSize: "13px",
    fontWeight: 700,
  },

  submittedBadge: {
    backgroundColor: "#dcfce7",
    color: "#15803d",
    borderRadius: "15px",
    padding: "4px 9px",
    fontSize: "11px",
    fontWeight: 700,
  },

  draftBadge: {
    backgroundColor: "#fef3c7",
    color: "#b45309",
    borderRadius: "15px",
    padding: "4px 9px",
    fontSize: "11px",
    fontWeight: 700,
  },

  recordBody: {
    padding: "15px 16px",
  },

  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
    padding: "7px 0",
    borderBottom: "1px solid #f1f5f9",
  },

  detailLabel: {
    color: "#64748b",
    fontSize: "12px",
    fontWeight: 600,
  },

  detailValue: {
    color: "#1e293b",
    fontSize: "12px",
    fontWeight: 600,
    textAlign: "right",
  },

  recordFooter: {
    padding: "12px 16px",
    borderTop: "1px solid #eef2f7",
  },

  feedbackButton: {
    width: "100%",
    border: "none",
    borderRadius: "8px",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    padding: "10px",
    fontSize: "13px",
    fontWeight: 700,
  },
 td: {
  padding: "12px 15px",
  borderRight: "1px solid #94a3b8",
  borderBottom: "1px solid #94a3b8",
  color: "#334155",
  fontSize: "14px",
  verticalAlign: "middle",
  backgroundColor: "#ffffff",
},

tdCenter: {
  padding: "12px 15px",
  borderRight: "1px solid #94a3b8",
  borderBottom: "1px solid #94a3b8",
  textAlign: "center",
  color: "#334155",
  fontSize: "14px",
  verticalAlign: "middle",
  backgroundColor: "#ffffff",
},
};

export default FeedbackReportt;